import { Component, OnInit, Input, SimpleChanges, OnChanges, Injector } from '@angular/core';
import { InputValue } from '../inputmodels/inputvalue.model';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { KindBoard } from 'src/utils/enums';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-input-value',
    templateUrl: './inputvalue.component.html',
    styleUrls: ['./inputvalue.component.css'],
    standalone: false
})
export class InputValueComponent extends PageBase implements OnInit, OnChanges {

  @Input() inputValue: InputValue = new InputValue();
  @Input() isHideLoading: boolean;
  inputItem: InputItem = new InputItem();
  calculoSaldoInsumo: string;

  constructor(public contextApplication: ContextApplication,
              public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.reset();
  }

  private reset() {
    this.inputValue.id = 0;
    this.inputValue.inputQuantityBalance = 0;
    this.inputValue.inputCurrency = '';
    this.inputValue.unitOfMeasure = '';
    this.inputValue.inputValueBalance = 0;
    this.calculoSaldoInsumo = '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputValue) {
      this.load();
    }
  }

  async load() {
    if (this.contextApplication.currentVision == KindBoard.Insumo.valueOf()) {
      this.calculoSaldoInsumo = this.literalsCp?.strSaldoInsumo;
    }
    else
    {
      this.calculoSaldoInsumo = this.literalsCp?.strSaldoInsumoTarefa;
    }
  }

  onReceiveLiterals(): void {}
}
